import yup from "src/validators/yup.Module";

export interface CategoriasCadastroDto {
  id: number;
  nome: string;
}

export const CategoriasCadastroSchema = yup.object().shape({
  nome: yup.string().min(3, "O nome deve ter no mínimo 3 caracteres"),
});
